export default {
    "name": "PartScreenStageOne",
    "kind": "HoudiniQuery",
    "hash": "9cddaa1ac06bc3826e7306df0e6aa2b00bce2189e7dc06f6f62f7873330dadea",

    "raw": `query PartScreenStageOne {
  inventoryConditions
  userPartStatusList: userStatuses(type: INVENTORY) {
    type
    status
    trigger
    partStatus
    description
  }
  userVehicleStatusList: userStatuses(type: VEHICLE) {
    type
    status
    trigger
    partStatus
    description
  }
  inventoryTypeList: inventoryTypes(filter: {active: true}) {
    inventoryTypeId: id
    typeSetId: setId
    name
    vehicle
    categories {
      id
      name
      description
    }
    partManufacturers: manufacturers {
      id
      name
      code
      active
    }
    requireSerialization
    id
  }
  glCategories {
    id
    name
  }
  vehicleMakes
  vendors(pagination: {pageSize: 0}) {
    items {
      id
      code
      companyName
      contactName
    }
  }
  sellPriceClasses {
    id
    name
    parent {
      id
      name
    }
  }
  saleClasses {
    code
    name
    id
  }
  session {
    permissionLevels {
      PARTS_CAN_EDIT_INFO
      PARTS_CAN_EDIT_COST
      PARTS_CAN_EDIT_PRICES
      PARTS_CAN_EDIT_QUANTITY
      PARTS_CAN_EDIT_GLCATEGORY
      PARTS_CAN_EDIT_STATUS
    }
    userAccount {
      authorizedStores {
        id
      }
      id
    }
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "inventoryConditions": {
                "type": "String",
                "keyRaw": "inventoryConditions",
                "visible": true
            },

            "userPartStatusList": {
                "type": "UserStatus",
                "keyRaw": "userPartStatusList(type: INVENTORY)",

                "selection": {
                    "fields": {
                        "type": {
                            "type": "UserStatusTypeEnum",
                            "keyRaw": "type",
                            "visible": true
                        },

                        "status": {
                            "type": "String",
                            "keyRaw": "status",
                            "visible": true
                        },

                        "trigger": {
                            "type": "Boolean",
                            "keyRaw": "trigger",
                            "visible": true
                        },

                        "partStatus": {
                            "type": "String",
                            "keyRaw": "partStatus",
                            "visible": true
                        },

                        "description": {
                            "type": "String",
                            "keyRaw": "description",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "userVehicleStatusList": {
                "type": "UserStatus",
                "keyRaw": "userVehicleStatusList(type: VEHICLE)",

                "selection": {
                    "fields": {
                        "type": {
                            "type": "UserStatusTypeEnum",
                            "keyRaw": "type",
                            "visible": true
                        },

                        "status": {
                            "type": "String",
                            "keyRaw": "status",
                            "visible": true
                        },

                        "trigger": {
                            "type": "Boolean",
                            "keyRaw": "trigger",
                            "visible": true
                        },

                        "partStatus": {
                            "type": "String",
                            "keyRaw": "partStatus",
                            "visible": true
                        },

                        "description": {
                            "type": "String",
                            "keyRaw": "description",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "inventoryTypeList": {
                "type": "InventoryType",
                "keyRaw": "inventoryTypeList(filter: {active: true})",

                "selection": {
                    "fields": {
                        "inventoryTypeId": {
                            "type": "UInt",
                            "keyRaw": "inventoryTypeId",
                            "visible": true
                        },

                        "typeSetId": {
                            "type": "Int",
                            "keyRaw": "typeSetId",
                            "nullable": true,
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "vehicle": {
                            "type": "Boolean",
                            "keyRaw": "vehicle",
                            "visible": true
                        },

                        "categories": {
                            "type": "Category",
                            "keyRaw": "categories",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "Int",
                                        "keyRaw": "id",
                                        "visible": true,
                                        "nullable": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    },

                                    "description": {
                                        "type": "String",
                                        "keyRaw": "description",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "partManufacturers": {
                            "type": "Manufacturer",
                            "keyRaw": "partManufacturers",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    },

                                    "code": {
                                        "type": "String",
                                        "keyRaw": "code",
                                        "visible": true
                                    },

                                    "active": {
                                        "type": "Boolean",
                                        "keyRaw": "active",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "requireSerialization": {
                            "type": "Boolean",
                            "keyRaw": "requireSerialization",
                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "glCategories": {
                "type": "GlCategory",
                "keyRaw": "glCategories",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true,
                            "nullable": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "vehicleMakes": {
                "type": "String",
                "keyRaw": "vehicleMakes",
                "visible": true
            },

            "vendors": {
                "type": "VendorList",
                "keyRaw": "vendors(pagination: {pageSize: 0})",

                "selection": {
                    "fields": {
                        "items": {
                            "type": "Vendor",
                            "keyRaw": "items",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "code": {
                                        "type": "String",
                                        "keyRaw": "code",
                                        "visible": true
                                    },

                                    "companyName": {
                                        "type": "String",
                                        "keyRaw": "companyName",
                                        "visible": true
                                    },

                                    "contactName": {
                                        "type": "String",
                                        "keyRaw": "contactName",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "sellPriceClasses": {
                "type": "SellPriceClass",
                "keyRaw": "sellPriceClasses",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "parent": {
                            "type": "SellPriceClass",
                            "keyRaw": "parent",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "saleClasses": {
                "type": "SaleClass",
                "keyRaw": "saleClasses",

                "selection": {
                    "fields": {
                        "code": {
                            "type": "String",
                            "keyRaw": "code",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "session": {
                "type": "Session",
                "keyRaw": "session",

                "selection": {
                    "fields": {
                        "permissionLevels": {
                            "type": "SessionPermissionLevels",
                            "keyRaw": "permissionLevels",

                            "selection": {
                                "fields": {
                                    "PARTS_CAN_EDIT_INFO": {
                                        "type": "PermissionLevel",
                                        "keyRaw": "PARTS_CAN_EDIT_INFO",
                                        "visible": true
                                    },

                                    "PARTS_CAN_EDIT_COST": {
                                        "type": "PermissionLevel",
                                        "keyRaw": "PARTS_CAN_EDIT_COST",
                                        "visible": true
                                    },

                                    "PARTS_CAN_EDIT_PRICES": {
                                        "type": "PermissionLevel",
                                        "keyRaw": "PARTS_CAN_EDIT_PRICES",
                                        "visible": true
                                    },

                                    "PARTS_CAN_EDIT_QUANTITY": {
                                        "type": "PermissionLevel",
                                        "keyRaw": "PARTS_CAN_EDIT_QUANTITY",
                                        "visible": true
                                    },

                                    "PARTS_CAN_EDIT_GLCATEGORY": {
                                        "type": "PermissionLevel",
                                        "keyRaw": "PARTS_CAN_EDIT_GLCATEGORY",
                                        "visible": true
                                    },

                                    "PARTS_CAN_EDIT_STATUS": {
                                        "type": "PermissionLevel",
                                        "keyRaw": "PARTS_CAN_EDIT_STATUS",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "userAccount": {
                            "type": "UserAccount",
                            "keyRaw": "userAccount",

                            "selection": {
                                "fields": {
                                    "authorizedStores": {
                                        "type": "Store",
                                        "keyRaw": "authorizedStores",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "id": {
                                        "type": "Int",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=e56287bfff26f2ee07a07191126674e89f959a07c1759e8189458f42aa83a9f7";